import React from 'react';
import { NavLink } from 'react-router-dom';
import '../App.css';
import planetLogo from '../images/001-planet.png';

const Navbar = () => {
  const activeLink = document.querySelectorAll('.link');
  activeLink.forEach((link) => {
    link.addEventListener('click', () => {
      link.addClass('active');
    });
  });
  return (
    <nav>
      <div className="logo">
        <img src={planetLogo} alt="logo" />
        <h1>
          Space Travelers&apos; Hub
        </h1>
      </div>
      <ul>
        <li>
          <NavLink to="/" className="link">Rocket</NavLink>
          <NavLink to="/mission" className="link">Mission</NavLink>
          <NavLink to="/profile" className="link profile">My Profile</NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
